import { combineReducers } from 'redux'

import request from './phone.request'
import verify from './phone.verify'

export default combineReducers({ request, verify })
